<template>
  <div class="tutor-detail-header">
    <h1 class="common__main-title">Timesheet</h1>
    <div class="d-flex justify-content-end">
      <div class="date">
        <font-awesome-icon :icon="'calendar'" class="calendar mr-2"/>
        <Datepicker
          :input-class="'timesheet-datepickerInput'"
          :wrapper-class="'lesson-date'"
          :calendar-class="'timesheet-calendar'"
          v-model="selectedDate"
          :minimum-view="'month'"
          :format="'yyyy/MM'"
          name="datepicker"
        />
      </div>
    </div>

    <div class="position-relative">
      <b-container fluid="lg" class="tutor-content">
        <div class="tutor-infomation" v-if="tutor">
          <div>
            <p>Tutor Name</p>
            <h2 class="tutor-name">{{ tutor.name }}</h2>
          </div>
          <span class="tutor-info">
            {{ tutor.hireDate | ymd }} {{ tutor.id }} {{ tutor.position.name }}
          </span>
          <slot></slot>
        </div>
      </b-container>
      <StatusCard class="status-card"/>
    </div>

    <div class="d-flex justify-content-between mb-3 changeMonth">
      <div @click="moveMonth(-1)" class="before-button">
        &lt;&lt; before
      </div>
      <div @click="moveMonth(+1)" class="next-button">
        next &gt;&gt;
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Datepicker from 'vuejs-datepicker';
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import _ from 'lodash'
import { Tutor } from '@/store/tutors/types'
import StatusCard from '@/components/parts/StatusCard.vue'

@Component({
  components: {
    Datepicker,
    StatusCard,
  },
  filters: {
    ymd: (value: Moment|null): string => value?.format('YYYY/MM/DD') || '',
  },
})
export default class TutorDetailHeader extends Vue {
  @Prop({ required: true }) date!: Moment

  private get tutor(): Tutor|undefined {
    const timesheet = this.$store.getters.findTimesheet({
      tutorId: this.$route.params.tutorId,
      yearMonth: this.date.format('YYYYMM'),
    })

    return _.get(timesheet, 'tutor')
  }

  private get selectedDate(): Date {
    return this.date.toDate()
  }

  private set selectedDate(date: Date) {
    this.$emit('changedDate', moment(date).startOf('month'))
  }

  private moveMonth(direction: number) {
    this.$emit(
      'changedDate',
      this.date.clone().add(direction, 'month').startOf('month'),
    )
  }
}
</script>

<style scoped>
.date {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px;
  text-align: center;
  background: #1cc8a0;
}

.calendar {
  color: #fff;
}

.tutor-content {
  background: #D8D8D8;
  padding:40px 0px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.tutor-name {
  line-height: 25px;
  font-size:25px;
  margin-bottom:10px;
}

.tutor-info {
  padding: 5px 10px;
  border-radius: 20px;
  background: #2E75B5;
  color: #fff;
}

.tutor-content p {
  text-align: left;
  margin-bottom: 5px;
}

.tutor-infomation {
  text-align: center;
  width: 30%;
}

.status-card {
  position: absolute;
  top: 40px;
  right: 10px;
}

.before-button, .next-button {
  border: 2px solid #AAAFB6;
  border-radius: 30px;
  color: #000;
  padding:5px 10px;
  -webkit-transition: .2s;
  transition: .2s;
  user-select:none;
}

.before-button:hover, .next-button:hover {
  cursor: pointer;
  background: #AAAFB6;
}
</style>

<style>

.timesheet-datepickerInput {
  width: 51px;
  color: #fff;
  background: none;
  border: none;
  cursor: pointer;
}

.timesheet-calendar {
  right: 0 ;
}

</style>
